import store from '@/store';
import axios from 'axios';
import {Module, VuexModule, Mutation, Action} from 'vuex-module-decorators';
import { Mutations, Actions, Endpoints } from '@/ts/store/Constants';
import ErrorResponse from '@/ts/ErrorResponse';


@Module({name: 'OrderDetails', namespaced: true})
export default class OrderDetails extends VuexModule {

    public showPayPage: boolean = null;

    get getShowPayPageStatus(): boolean {
        return this.showPayPage;
    }

    @Mutation
    public SET_SHOW_PAYMENT_PAGE_STATUS(status: any) {
        this.showPayPage = status;
    }

}
